export const LIST_BRANCH_PACKAGE_CATEGORY_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_FAIL'

export const PATCH_BRANCH_PACKAGE_CATEGORY_REQUEST =
  'PATCH_BRANCH_PACKAGE_CATEGORY_REQUEST'
export const PATCH_BRANCH_PACKAGE_CATEGORY_SUCCESS =
  'PATCH_BRANCH_PACKAGE_CATEGORY_SUCCESS'
export const PATCH_BRANCH_PACKAGE_CATEGORY_FAIL =
  'PATCH_BRANCH_PACKAGE_CATEGORY_FAIL'

export const DETAIL_BRANCH_PACKAGE_CATEGORY_REQUEST =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_REQUEST'
export const DETAIL_BRANCH_PACKAGE_CATEGORY_SUCCESS =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_SUCCESS'
export const DETAIL_BRANCH_PACKAGE_CATEGORY_FAIL =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_DETAIL_FAIL'

export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_REQUEST =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_REQUEST'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_SUCCESS =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_SUCCESS'
export const LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_FAIL =
  'LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_HEADER_FAIL'

export const DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST'
export const DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS'
export const DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL =
  'DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL'

export const LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST =
  'LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST'
export const LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS =
  'LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS'
export const LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL =
  'LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL'
